<template>
  <div class="gift-box__header">
    <AccountIconWh24 :image-url="senderIcon" />
    <div class="gift-box__suffix-message">
      <div class="gift-box__sender-name body-bold">
        {{ senderName }}
      </div>
      <div class="gift-box__suffix module-text">
        さんより
      </div>
    </div>
  </div>
</template>

<script>
import AccountIconWh24 from '../../atoms/account_icons/AccountIconWh24'
export default {
  components: { AccountIconWh24 },
  props: {
    senderIcon: {
      type: String,
      require: true,
      default: ''
    },
    senderName: {
      type: String,
      require: true,
      default: ''
    }
  }
}
</script>
